
require('../sass/priceTable.scss');


var
	Util 				= require('../../../common/util.js'),
	filterPriceAndFillIntoTable = require('./filterPriceAndFillIntoTable.js'),
	testData 			= require('../testData/testPrice.js'),
	progressBar			= require('../../../common/progressBar/progressBar.js'),
    hotelPolicyTmpl     = require('../templates/hotelPolicyTmpl.ejs'),
    hotelIntroductionTmpl     = require('../templates/hotelIntroductionTmpl.ejs'),


	// 设置小礼包
	setMarketing = function(o, p, j){
		var copy = $.extend(true, {}, p);

		// 将裸房的小礼包信息置空
		p.isHasMarketing = 0;
		p.marketing = null;
		p.marketingStr = 'isHasMarketing=0';

		if(copy.marketing){
			var giftStartTime = copy.marketing.startTime.slice(0, 11) + '00:00:00',
				giftEndTime = copy.marketing.endTime.slice(0, 11) + '23:59:59',
				marketingPrice = copy.marketing.marketingPrice || 0,
				totalPrice = 0;
      // 2021-08-24 新增：isPack = 1 打包才在总价格上加上礼包价，反之为免费赠送礼包
      if(copy.marketing.isPack) {
      //pricingMethod = 1 礼包价直接加在总价上。反之加到每天计算总价
			if(copy.marketing.pricingMethod){
				// 将小礼包价格加到每一天的单价里
				for (var k = 0; k < copy.nightlyPriceList.length; k++) {
					totalPrice += copy.nightlyPriceList[k].salePrice;
				}

				// 重新计算总价
				copy.totalPriceRMB = totalPrice * parseInt($.queryingHotelParams.selRoomNum) + marketingPrice;
			}else{
				// 将小礼包价格加到每一天的单价里
				for (var k = 0; k < copy.nightlyPriceList.length; k++) {
					var q = copy.nightlyPriceList[k];

					if( new Date(giftStartTime) < new Date(q.date) && new Date(q.date) < new Date(giftEndTime) ){
						q.salePrice += marketingPrice;
					}

					totalPrice += q.salePrice;
				}

				// 重新计算总价
				copy.totalPriceRMB = totalPrice * parseInt($.queryingHotelParams.selRoomNum);
			}
    }

			copy.marketingStr =
				'isHasMarketing=1&marketingPrice=' + marketingPrice +
				'&startTime=' + copy.marketing.startTime +
				'&endTime=' + copy.marketing.endTime;

			// 如果 isPack = 1，复制一条裸房价(没有礼包的)
			copy.marketing.isPack
				? o.roomTypePrices.splice((j++ + 1), 0, copy)
				: o.roomTypePrices.splice(j, 1, copy);

		}

		return j;
	},

	// 为价格数据设置新的属性，使之适合模板
	setNewAttrForPriceData = function(res, type){

		if(res.data[type]){
			var rowSpan = 0;
			var roomNum = $('.s-i-room-num').attr('data-value')

			for (var i = 0; i < res.data[type].length; i++) {
				var o = res.data[type][i];

				rowSpan += o.roomTypePrices.length;

				for (var j = 0; j < o.roomTypePrices.length; j++) {
					var p = o.roomTypePrices[j];

					p.cancellationText = p.isCanCancle ? '可取消' : '不可取消';	// cancellationType --> isCanCancle

					// 设置房态显示    0：剩余库存  1畅订  2：待查  3：满房 5不可超售
					if( p.roomStatus === 3 ){
						p.roomStatusText = '<span class="red">满房</span>';
					}else if( p.roomStatus === 2 || p.roomStatus === 6){
						if(window.temporaryDemand1470){
							p.roomStatusText =
								!!~$.inArray(parseInt(p.supplierId), window.temporaryDemand1470)
									? '<span class="green">剩余[' + roomNum + ']</span>'
									: '<span class="purple">待查</span>';
						}else{
							p.roomStatusText = '<span class="purple">待查</span>';
						}
					}else if( p.roomStatus === 0 || p.roomStatus === 5 ){
						p.roomStatusText =
							p.isTimeLimitConfirSupplier === 1
								? '<span class="blue">60秒确认</span>'
								: '剩余库存';
					}else if( p.roomStatus === 1 ){
						p.roomStatusText =
							p.isTimeLimitConfirSupplier === 1
								? '<span class="blue">60秒确认</span>'
								: '<span class="green">畅订</span>';
					}

					if( p.roomStatusText === '剩余库存' ){
						var stockArr = [];
						for (var k = 0; k < p.nightlyPriceList.length; k++) {
							var q = p.nightlyPriceList[k];
							if( q.status === 1 ){ q.stock = 999; }	// 畅订情况下库存为 0 ！
							stockArr.push(q.stock - q.sellStock);
						}

						var minStock = Math.min.apply(this, stockArr);
						p.roomStatusText =
							minStock < 1
								? '<span class="red">满房</span>'
								: '<span class="green">剩余[' + Math.min.apply(this, stockArr) + ']</span>';
					}

					if(!p.isHasMarketing) p.isHasMarketing = 0;
					j = setMarketing(o, p, j);
				}
			}

			res.data[type].rowSpan = rowSpan;
		}
	},

	// 对价格数据进行预处理，使之适合模板
	initPriceData = function(res){
		if(res.data){
			// 分别设置 "推荐"、"其他" 的相关新属性
			setNewAttrForPriceData(res, 'roomTypeBasesRecommend');
			setNewAttrForPriceData(res, 'roomTypeBases');
		}
	},

	queryPriceFunc = function (that, priceTableTmpl, hotelItem, res, firstQuery, progress) {
        // 不是第一次查询显示加载中线性条,并且时间选择器,搜索按钮禁用
		if(progress && !firstQuery){
			progress.end();

			setTimeout(function (param) {
				$('.search-line-btn').removeClass('disabled');
				$('.s-i-dates-input').removeClass('disabled');
				$('.s-i-dates-input').prop('disabled',false);
			}, 200);
		}

		that.priceList = res.data || [];

		if( res.returnCode === 1 ){
			var lowestPriceWrap = hotelItem.find('.hli-lowest-price-wrap');
			// 设置起价（只在第二次实查时才设置）
			if(lowestPriceWrap.length && lowestPriceWrap.html().indexOf('起') === -1 && !firstQuery){
				var
					lowestPriceStr =
						res.data.priceMin
							? '￥<span class="hli-lowest-price">' + res.data.priceMin + '</span>起'
							: '满房&nbsp;&nbsp;&nbsp;&nbsp;';		// 无相关价格！

				hotelItem.find('.hli-lowest-price-wrap').html(lowestPriceStr).removeClass('hidden');
			}

			// 对价格数据进行预处理，使之适合模板
			initPriceData(res);
			that.priceList = res.data;
			filterPriceAndFillIntoTable( priceTableTmpl, $(that), firstQuery );
            // console.log('priceTableTmpl',priceTableTmpl);
            // console.log('$(that)',$(that));
            // console.log('firstQuery',firstQuery);

		}else if( res.returnCode === -400001 ){
            hotelItem.find('.hli-price-list-wrap').html('');
		}else{		//  res.returnCode === -400301/-400501
			var parent = $(that).closest('.hl-item').find('.hli-price-list-wrap');
			var tmpStr = '<div class="hli-error-msg">' + res.errinfo + '</div>';

			// 设置起价
			hotelItem.find('.hli-lowest-price-wrap').html(res.errinfo);

			parent.html(tmpStr)
		}
	},

	// 查价
	queryPrices = function(that, getParams, priceTableTmpl){
		that.queryingPrice = true;

		var
			p = typeof getParams === 'function' ? getParams() : getParams,
			hotelItem = $(that).closest('.hl-item'),
			params = {
				hotelId				: $(that).attr('data-hotelid') || p.infoIds,
				checkInDate			: p.startDate,
				checkOutDate		: p.endDate,
				roomNum				: p.selRoomNum,
				adultNum			: p.adultNum,
				childrenNum			: p.childrenNum,
				childrenAgesStr		: p.childrenAgesStr,
				// 只有在勾选了 "可加早"、"可加床" 才在查价的时候查加床加早
				isSearchSurcharge	: $(".d-s-item[data-attr='bedbreakfast']:checked").length ? 1 : 0
			};

		if(!params.hotelId){
			alert("酒店查价没有带 hotelId 参数！")
			return false;
		}

		$('.search-line-btn').addClass('disabled');
		$('.s-i-dates-input').addClass('disabled');
		$('.s-i-dates-input').prop('disabled',true);
		

		var loadingStr =
                '<div class="fzg-loading-wrap">' +
                    '<img src="https://qnb.oss-cn-shenzhen.aliyuncs.com/real_1514022140288.gif"/>' +
                '</div>';

		hotelItem.find('.hli-price-list-wrap').html(loadingStr);

		// 初始化进度条
		var progress = progressBar({
			elem: hotelItem.find('.progress-outer')[0],
		});

		// 第一次查价，只查落地
		$.post('/hotel/getHotelPriceListInStock.do', params, function(res){	
            // 落地:getHotelPriceListInStock 实时:getHotelPriceRealTime  实时+落地:getHotelPriceList
            
            queryPriceFunc(that, priceTableTmpl, hotelItem, res, true, progress);

			if( res.returnCode === 1 ){
                
				// 第二次查价，查实时 getHotelPriceRealTime  !firstQuery  
               
				$.post('/hotel/getHotelPriceRealTime.do', params, function(result){	

                    if(result.returnCode === 1) {
                        let { roomTypeBases:bases,roomTypeBasesRecommend:recommend } = res.data;
                        
                        if(result && result.data) {    //如果第二次查价有数据,进行操作
                            let { roomTypeBases,roomTypeBasesRecommend } = result.data;

                            //  待办: 根据roomTypeBasesRecommend返回的第一条数据  创建一个模版.ejs
                            if(roomTypeBasesRecommend && roomTypeBasesRecommend.length && roomTypeBasesRecommend[0].roomTypePrices && roomTypeBasesRecommend[0].roomTypePrices.length) {
                                let roomTypePricesOne = roomTypeBasesRecommend[0].roomTypePrices[0];
                                checkinPolicy(roomTypePricesOne)
                            }

                            let mergedArray;
                            let mergedArrayRecommend;
                            if(roomTypeBases) {      //如果第二次查价房型有数据,进行操作
                                if(bases) {          //如果第一次查价房型有数据,进行操作

                                    /**
                                     * 1.合并特价房型
                                     * 2.根据totalPriceRMB进行从小到大排序
                                     * 3.根据数组长度剪切
                                     */
                                    mergedArrayRecommend = res.data.roomTypeBasesRecommend.concat(roomTypeBasesRecommend);
                                    mergedArrayRecommend.sort((a, b) => {    
                                        return a.roomTypePrices[0].totalPriceRMB - b.roomTypePrices[0].totalPriceRMB;
                                    });
                                    if(mergedArrayRecommend.length == 2) {
                                        mergedArrayRecommend = mergedArrayRecommend.slice(0,1)
                                    } else if(mergedArrayRecommend.length == 4) {
                                        mergedArrayRecommend = mergedArrayRecommend.slice(0,2)
                                    } else if(mergedArrayRecommend.length == 3) {
                                        if(mergedArrayRecommend[0].roomTypePrices.length == 2) {
                                            mergedArrayRecommend = mergedArrayRecommend.slice(0,1)
                                        } else {
                                            mergedArrayRecommend = mergedArrayRecommend.slice(0,2)
                                        }
                                    } else if(mergedArrayRecommend.length == 1) {
                                        mergedArrayRecommend = mergedArrayRecommend.slice(0,1)
                                    } else {
                                        mergedArrayRecommend = mergedArrayRecommend.slice(0,2)
                                    }
                                    res.data.roomTypeBasesRecommend = mergedArrayRecommend;

                                    /**
                                     * 1.合并基础房型
                                     * 2.房型是:其他 Other的合并
                                     * 3.根据totalPriceRMB进行从小到大排序
                                     */
                                    // 合并两个接口的数组
                                    mergedArray = res.data.roomTypeBases.concat(roomTypeBases);

                                    // 房型是:其他 Other的合并
                                    let newArr = [];
                                    for (let i = mergedArray.length - 1; i >= 0; i--) {
                                        if(mergedArray[i].roomName == '其他 Other') {
                                            newArr.push(mergedArray[i])
                                            mergedArray.splice(i,1)
                                        }
                                    }
                                    if(newArr.length > 1) {
                                        newArr[0].roomTypePrices = newArr[0].roomTypePrices.concat(newArr[1].roomTypePrices);
                                        newArr.splice(1,1)
                                        newArr[0].roomTypePrices.sort((a, b) => {    
                                            return a.totalPriceRMB - b.totalPriceRMB;
                                        })
                                    }

                                    // 继续合并两个数组
                                    mergedArray = mergedArray.concat(newArr)

                                    //排序
                                    mergedArray.sort((a, b) => {    
                                        return a.roomTypePrices[0].totalPriceRMB - b.roomTypePrices[0].totalPriceRMB;
                                    });
                                    res.data.roomTypeBases = mergedArray;

                                    queryPriceFunc(that, priceTableTmpl, hotelItem, res, null, progress);


                                } else {        //如果第一次查价房型没有数据,直接输出第二次实时查价数据
                                    queryPriceFunc(that, priceTableTmpl, hotelItem, result, null, progress);
                                }
                            } else {    //如果第二次查价房型没有数据,直接输出第一次落地查价数据
                                queryPriceFunc(that, priceTableTmpl, hotelItem, res, null, progress)
                            }                 
                        } else {    //如果第二次查价没有数据,直接输出第一次落地查价数据
                            queryPriceFunc(that, priceTableTmpl, hotelItem, res, null, progress)
                        }
                    } else {    
                        // 第二次实时接口调用失败,直接输出第一次落地查价数据
                        queryPriceFunc(that, priceTableTmpl, hotelItem, res, null, progress)
                    }

                    
                    progress.end();
				}, 'noAnimation');

                
			}else{
				// 如果第一次查价不能返回正确的内容，则终止进度条
				progress.end();
				if(res.returnCode === -400001){
                    $('.no-login-box').show();
				}
			}
		}, 'noAnimation');
	};

    // 针对EAN展示酒店入住政策
    let checkinPolicy = function(roomTypePrices) {
        console.log("roomTypePrices", roomTypePrices);

        let o = roomTypePrices;
        if($('#checkin-policy-content .hotel-detail-item').length===0) {
            if(o.policies || o.checkInInstructions || o.specialCheckInInstructions) {
                let tip = $(".hotel-detail-content-tip").html();
                if(tip && tip !== "无" && o.specialCheckInInstructions) {
                    if(o.specialCheckInInstructions.indexOf(tip) !== -1) {
                        $(".hotel-detail-item-tip").hide()
                    }
                }

                let introduction = $(".hotel-detail-content-introduction").html();
                if(introduction && o.checkInInstructions) {
                    if(o.checkInInstructions.indexOf(introduction) !== -1) {
                        $(".hotel-detail-item-introduction").hide()
                    }
                }
                
                $('#checkin-policy-content').html(hotelPolicyTmpl({o}))

                // ean 酒店简介
                if( o.addAttrMap && 
                    ( 
                           o.addAttrMap.descriptions_amenities 
                        || o.addAttrMap.descriptions_dining 
                        || o.addAttrMap.descriptions_renovations
                        || o.addAttrMap.descriptions_businessAmenities 
                        || o.addAttrMap.descriptions_rooms
                        || o.addAttrMap.descriptions_location
                        || o.addAttrMap.descriptions_headline
                    )
                ) {
                    let info = '';

                    if(o.addAttrMap.descriptions_amenities) {
                        info += o.addAttrMap.descriptions_amenities
                    }
                    if(o.addAttrMap.descriptions_dining) {
                        info += '<br /><br />' + o.addAttrMap.descriptions_dining
                    }
                    if(o.addAttrMap.descriptions_renovations) {
                        info += '<br /><br />' + o.addAttrMap.descriptions_renovations
                    }
                    if(o.addAttrMap.descriptions_businessAmenities) {
                        info += '<br /><br />' + o.addAttrMap.descriptions_businessAmenities
                    }
                    if(o.addAttrMap.descriptions_rooms) {
                        info += '<br /><br />' + o.addAttrMap.descriptions_rooms
                    }
                    if(o.addAttrMap.descriptions_location) {
                        info += '<br /><br />' + o.addAttrMap.descriptions_location
                    }
                    if(o.addAttrMap.descriptions_headline) {
                        info += '<br /><br />' + o.addAttrMap.descriptions_headline
                    }

                    $('#hotel-introduction').html(hotelIntroductionTmpl({o:info}))
                }
            }
        }
    }

// 酒店价格列表
module.exports = queryPrices



// WEBPACK FOOTER //
// ./src/common/hotelPriceUtil/modules/hotelPriceUtil.js